import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns"; // or moment/luxon
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import styled from "styled-components";

const EnviDatePicker = ({ date, name }) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <StyledDatePicker
        autoOk
        label={name}
        value={date.get}
        onChange={date.set}
        format="dd/MM/yyyy"
      />
    </MuiPickersUtilsProvider>
  );
};

export default EnviDatePicker;

const StyledDatePicker = styled(DatePicker)`
  // border-bottom: 2px solid rgba(236, 236, 236, 0.83);
  // label,
  // input {
  //   color: white;
  // }

  // width: 100%;
  // color: blue;
`;
